const PrintDate = (unixTimeStamp) => {
    var date = new Date(unixTimeStamp);
    return date.toLocaleTimeString("default");
};

export default PrintDate;